import { render } from "./LabDocumentsFiles.vue?vue&type=template&id=8f9e6bd0"
import script from "./LabDocumentsFiles.vue?vue&type=script&lang=js"
export * from "./LabDocumentsFiles.vue?vue&type=script&lang=js"

import "./LabDocumentsFiles.vue?vue&type=style&index=0&id=8f9e6bd0&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/labDocuments/LabDocumentsFiles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f9e6bd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f9e6bd0', __exports__)) {
    console.log('reload')
    api.reload('8f9e6bd0', __exports__)
  }
  
  module.hot.accept("./LabDocumentsFiles.vue?vue&type=template&id=8f9e6bd0", () => {
    console.log('re-render')
    api.rerender('8f9e6bd0', render)
  })

}


export default __exports__